import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";

// Customer
import customer from "./customer";

// Wallet
import wallet from "./wallet";

// customization
import customization from "./customization";

// Profile Feed
import profile_feed from "./profile_feed";

// Fund Request
import fund_request from "./fund_request";

// Withdraw Request
import withdrawl_request from "./withdrawl_request";

// Dashboard
import dashboard from "./dashboard";

// Dashboard
import rating_and_feedback from "./rating_and_feedback";

export const store = configureStore({
  reducer: {
    // settings
    settings: settings,
    //auth
    auth: auth,
    //common
    common: common,
    //masters
    masters,
    //Wallet
    wallet,
    //Customer
    customer,
    //customization
    customization,
    //Profile Feed
    profile_feed,
    // fund_request
    fund_request,
    // withdrawl_request
    withdrawl_request,
    // dashboard
    dashboard,
    // rating_and_feedback
    rating_and_feedback,
  },
});
